
// Modify default `options`
document.addEventListener('algolia.hooks.initialize', function() {

  algoliaShopify.hooks.registerHook('beforeInstantSearchMainTemplate', function(defaultTemplate, data, html) {
    return html `
        <div class="ais-page">
            <div class="ais-facets-button">
                Show filters
            </div>
            <div class="ais-search-box-container" style="display:none;"></div>
            <span class="ais-clear-input-icon" style="display:none;"></span>
            <div class="ais-facets">
                <div class="ais-clear-refinements-container"></div>
                <div class="ais-current-refined-values-container"></div>
                ${data.facets.map(facet =>
                        html`
                            <div class="ais-facet-dropdown-wrapper ais-facet-${facet.type} ais-facet-${facet.escapedName}">
                                <label for="${facet.escapedName}"
                                       class="ais-range-slider--header ais-facet--header ais-header">${facet.title}</label>
                                <input class="ais-dropdown-checkbox" type="checkbox" id="${facet.escapedName}"
                                       name="dropdown"/>
                                <div class="ais-facet-${facet.escapedName}-container ais-facet-dropdown-container"></div>
                            </div>`
                )}
            </div>
            <div class="ais-block">
                <div class="ais-search-header">
                    <div class="ais-stats-container"></div>
                    <div class="ais-change-display">
                        <span class="ais-change-display-block ais-change-display-selected"><i
                                class="fa fa-th-large"></i></span>
                        <span class="ais-change-display-list"><i class="fa fa-th-list"></i></span>
                    </div>
                    <div class="ais-sort">
                        ${data.multipleSortOrders ?
                                html`${algoliaShopify.translations.sortBy} <span class="ais-sort-orders-container"></span>`
                                : html`${algoliaShopify.translations.sortBy} ${algoliaShopify.translations.relevance}`
                        }
                    </div>
                </div>
                <div class="ais-hits-container ais-results-as-block"></div>
            </div>
            <div class="ais-pagination-container"></div>
        </div>`
  });

  algoliaShopify.hooks.registerHook('beforeInstantSearchProductTemplate', function(defaultTemplate, hit, html) {
    return html `
        <div data-algolia-index="${hit.index}" data-algolia-position="${hit.productPosition}"
             data-algolia-queryid="${hit.queryID}" data-algolia-objectid="${hit.objectID}"
             class="ais-hit ais-product twcss-shadow-md twcss-duration-300 !twcss-p-0"
             data-handle="${hit.handle}"
             data-variant-id="${hit.objectID}"
             data-distinct="${hit._distinct}"
        >

            <div class="ais-hit--image !twcss-block twcss-bg-no-repeat twcss-bg-contain twcss-bg-center twcss-h-36"
                 style="background-image: url('${algoliaShopify.helpers.mediumImage(hit)}')"></div>
            <div class="ais-hit--details !twcss-mt-4 !twcss-px-4">
                <p class="ais-hit--title !twcss-overflow-visible !twcss-whitespace-normal !twcss-text-center !twcss-text-base twcss-block">
                    <a data-algolia-index="${hit.index}"
                       data-algolia-position="${hit.productPosition}"
                       data-algolia-queryid="${hit.queryID}"
                       data-algolia-objectid="${hit.objectID}"
                       href="${algoliaShopify.helpers.instantsearchLink(hit)}"
                       onclick="void(0)"
                       title="${algoliaShopify.helpers.fullTitle(hit.title, hit._distinct, hit.variant_title)}"
                       class="!twcss-text-gray-800 !twcss-font-semibold  twcss-mb-4 !twcss-ml-0 "
                    >
                        ${hit.title}
                    </a>
                </p>
                <p class="!twcss-my-4">
                    ${hit.sku && hit.variants_count <= 1 && html`<span class="algolia-sku">${hit.sku}</span>`}
                </p>
                <p class="ais-hit--price !twcss-text-gray-900 twcss-flex twcss-flex-wrap twcss-justify-center !twcss-my-8">
                    ${!!window.customerId && hit.variants_max_price > hit.variants_min_price && html`<span class="!twcss-leading-8 twcss-font-bold twcss-block twcss-rounded twcss-w-full twcss-text-center">Alkaen.</span>`}

                    ${!!window.customerId && html`<span
                                  class="twcss-text-sm !twcss-leading-8 price-item price-item--regular"
                                  >${hit.variants_min_price} €</span>`}
                    ${!!window.customerId && html`<span
                            class="pst-discount !twcss-leading-8 twcss-font-bold twcss-block twcss-text-orange-500 !twcss-ml-2 twcss-animate-pulse twcss-w-24 twcss-h-8 twcss-bg-slate-200 twcss-rounded'"
                            data-sku="${hit.sku}"></span>`}
                    ${!!window.customerId && html`<span
                                                class="pst-price !twcss-leading-8 twcss-w-full twcss-text-center twcss-font-bold twcss-block twcss-animate-pulse twcss-h-8 twcss-bg-slate-200 twcss-rounded'"
                                                data-sku="${hit.sku}"></span>`}

                </p>
                ${!!window.customerId && hit.inventory_quantity >= 1 && html`
                    <p class="ais-hit--inventory twcss-h-8 !twcss-my-4 twcss-text-pgreen twcss-text-center twcss-flex twcss-justify-center">
                        <span class="twcss-rounded-full twcss-h-4 twcss-w-4 !twcss-block twcss-bg-pgreen !twcss-m-2"></span>
                        ${hit.inventory_quantity} ${hit.meta.custom.uom}
                    </p>
                `}
                ${!!window.customerId && hit.inventory_quantity < 1 && html`
                    <p class="ais-hit--inventory twcss-h-8 !twcss-my-4 twcss-text-pgreen twcss-text-center twcss-flex twcss-justify-center">
                        <span class="twcss-rounded-full twcss-h-4 twcss-w-4 !twcss-block twcss-bg-orange-500 !twcss-m-2"></span>
                    </p>
                `}
            </div>
            <div>
                <a href="${algoliaShopify.helpers.instantsearchLink(hit)}">
                    <button class="twcss-rounded-md twcss-w-full twcss-py-4 twcss-mt-4 twcss-bg-pgreen twcss-text-white twcss-uppercase twcss-font-semibold hover:twcss-bg-pgreen-dark">
                        Osta
                    </button>
                </a>
            </div>
        </div>`
  })


  algoliaShopify.hooks.registerHook('beforeInstantSearchNoResultTemplate', function(_defaultTemplate, html) {
    return html`
        <div class="ais-hit-empty">
            <div class="ais-hit-empty--title">
                ${algoliaShopify.translations.noResultFound}
            </div>
            <div class="ais-hit-empty--clears">
                ${algoliaShopify.translations.try} ${' '}
                <a class="ais-hit-empty--clear-filters ais-link">
                    ${algoliaShopify.translations.clearFilters} ${' '}
                </a>
                ${algoliaShopify.translations.or} ${' '}
                <a class="ais-hit-empty--clear-input ais-link">
                    ${algoliaShopify.translations.changeInput}
                </a>
            </div>
        </div>
    `;
  });
  algoliaShopify.hooks.registerHook('beforeInstantSearchFacetItemTemplate', function(_defaultTemplate, item, html) {
    return html`
        <label class="${item.cssClasses.label}">
            ${item.type === 'disjunctive' &&
            (item.isRefined
                    ? html`
                        <input
                                type="checkbox"
                                class="${item.cssClasses.checkbox}"
                                checked
                        />
                    `
                    : html`
                        <input type="checkbox" class="${item.cssClasses.checkbox}" />
                    `)}
            ${item.label}
            <span class="${item.cssClasses.count}">
          ${algoliaShopify.helpers.formatNumber(item.count)}
        </span>
        </label>
    `;
  });
  algoliaShopify.hooks.registerHook('beforeInstantSearchShowMoreTemplate', function(_defaultTemplate, data, html) {
    return html`
        <span
        >${data.isShowingMore
                ? algoliaShopify.translations.showLess
                : algoliaShopify.translations.showMore}</span
        >
    `;
  });
});

